/** v1 `utils/audio.ts`: the start jingle and the disconnect beep (WebAudio, shell-only). */

const context = (): AudioContext =>
	new (
		window.AudioContext ??
		(window as unknown as { webkitAudioContext: typeof AudioContext })
			.webkitAudioContext
	)();

export const playBeep = (frequency = 440, duration = 0.5, volume = 0.1) => {
	const ctx = context();
	const osc = ctx.createOscillator();
	const gain = ctx.createGain();
	osc.type = "sine";
	osc.frequency.setValueAtTime(frequency, ctx.currentTime);
	gain.gain.setValueAtTime(volume, ctx.currentTime);
	osc.connect(gain);
	gain.connect(ctx.destination);
	osc.start();
	osc.stop(ctx.currentTime + duration);
};

const THAXTED: ReadonlyArray<readonly [number, number]> = [
	[392.0, 0.5],
	[523.25, 0.5],
	[587.33, 0.5],
	[659.25, 0.5],
	[783.99, 1.0],
];

export const playThaxted = () => {
	const ctx = context();
	let start = ctx.currentTime;
	for (const [frequency, duration] of THAXTED) {
		const osc = ctx.createOscillator();
		const gain = ctx.createGain();
		osc.type = "sine";
		osc.frequency.value = frequency;
		gain.gain.setValueAtTime(0.3, start);
		gain.gain.linearRampToValueAtTime(0, start + duration - 0.05);
		osc.connect(gain);
		gain.connect(ctx.destination);
		osc.start(start);
		osc.stop(start + duration);
		start += duration;
	}
};
